<template>
  <!-- wrapper(s) -->
  <div class="wrapper">
    <Header class="header" :val="headerTitle"></Header>
    <div class="container">
      <!-- content(s) -->
      <div id="content">
        <section class="hr">
          <div class="titArea">
            <h2 class="titH4">결제정보</h2>
          </div>
          <table class="tableY noLine">
            <colgroup>
              <col style="width:110px" />
              <col style="width:auto" />
            </colgroup>
            <tbody>
              <tr>
                <td class="th">점검상품</td>
                <td>음식물처리기(제품코드)</td>
              </tr>
              <tr>
                <td class="th">접수유형</td>
                <td class="bold">철거비</td>
              </tr>
            </tbody>
          </table>
          <!-- table (e) -->

          <!-- 서비스비용 쿠폰 1차 오픈때 제공예정 없음 -->
          <div class="formArea">
            <select class="ipt" id="agency_4" title="쿠폰 선택">
              <option value="" selected="selected">쿠폰을 선택해주세요.</option>
              <option value="">선택1</option>
              <option value="">선택2</option>
            </select>
          </div>
          <!-- 서비스비용 쿠폰 1차 오픈때 제공예정 없음 -->

          <div class="orderSum">
            <ul class="infoList">
              <li>
                <span class="item">결제금액</span>
                <span class="val">
                  <span class="money">
                    <em>33,000</em>
                    원
                  </span>
                </span>
              </li>
            </ul>
          </div>
        </section>

        <section class="hr">
          <div class="titArea">
            <h2 class="titH4">결제수단 선택</h2>
          </div>

          <div class="formArea">
            <ul class="iptGroup iptBtn">
              <li>
                <input type="radio" class="ipt" name="rdosort" id="btn_1" checked="checked" />
                <label for="btn_1"><span class="ico">카드결제</span></label>
              </li>
            </ul>

            <span class="label">카드선택</span>
            <select class="ipt" title="카드선택">
              <option value="" disabled="disabled" selected="selected">선택해주세요</option>
              <option value="">선택1</option>
              <option value="">선택2</option>
            </select>
            <p class="txtList_remark">본인 결제수단만 진행 가능</p>

            <span class="label">카드번호</span>
            <div class="setCard">
              <input type="tel" class="ipt" maxlength="4" title="카드번호 첫번째 4자리" value="" />
              <span class="sign" aria-hidden="true">-</span>
              <input type="tel" class="ipt" maxlength="4" title="카드번호 두번째 4자리" value="" />
              <span class="sign" aria-hidden="true">-</span>
              <input type="tel" class="ipt" maxlength="4" title="카드번호 세번째 4자리" value="" />
              <span class="sign" aria-hidden="true">-</span>
              <input type="tel" class="ipt" maxlength="4" title="카드번호 마지막 4자리" value="" />
            </div>

            <span class="label">유효기간</span>
            <div class="setPeriod">
              <input type="tel" class="ipt" maxlength="2" title="유효기간 월 2자리" placeholder="MM" />
              <span class="sign" aria-hidden="true">/</span>
              <input type="tel" class="ipt" maxlength="2" title="유효기간 년 2자리" placeholder="YY" />
            </div>

            <span class="label">비밀번호</span>
            <div class="setPw">
              <input type="password" class="ipt" maxlength="2" title="비밀번호 앞 2자리" placeholder="앞 2자리" />
              <input type="password" class="ipt" maxlength="2" title="비밀번호 뒤 2자리" value="**" readonly="readonly" />
            </div>

            <span class="label">생년월일</span>
            <div class="setBirth">
              <input type="tel" class="ipt" maxlength="4" title="생년월일 년도 4자리" placeholder="1990" />
              <span class="sign" aria-hidden="true">/</span>
              <input type="tel" class="ipt" maxlength="2" title="생년월일 월 2자리" placeholder="01" />
              <span class="sign" aria-hidden="true">/</span>
              <input type="tel" class="ipt" maxlength="2" title="생년월일 일 2자리" placeholder="01" />
            </div>

            <span class="singleIpt">
              <input type="checkbox" class="ipt" checked="checked" id="chk2" />
              <label class="normal" for="chk2">
                <span>
                  결제할 항목의 금액정보를 확인했으며 이에 동의합니다.
                  <br />
                  (전자상거래법 제8조2항)
                </span>
              </label>
            </span>
            <p class="fieldMsg error" id="idMsg">결제내용에 동의해주세요</p>
            <p class="fieldMsg error" id="idMsg">결제 정보에 오류가 있습니다. 다시 확인해주세요</p>
          </div>
        </section>

        <div class="btnArea sticky">
          <button type="button" class="btn_p">결제하기</button>
        </div>
      </div>
      <!-- content(e) -->
    </div>
    <!-- container(e) -->
    <footer class="footer"></footer>
  </div>
  <!-- wrapper(e) -->
</template>

<script>
import QuickMenu from '@/views/app/comm/QuickMenu';
export default {
  name: 'asPaymentStep2',
  data: function() {
    return {
      headerTitle: 'AS비용 결제',
    };
  },
  components: {
    QuickMenu,
  },
  mounted() {},
};
</script>
